import { User } from '@models/user.model';
import { Notifications } from '@models/notifications';
import { Favorite } from '@models/favorite';
import { Sinalization } from '@models/sinalization';
import { Alert } from '@models/alerts';

export interface UserState {
    profile: User;
    notification: Notifications[];
    favorite: Favorite[];
    sinalization: Sinalization[];
    notificationCounter: number;
    alert: Alert[];
    hideOnboarding: boolean;
    loaded: UserDataLoaded;
}

export interface UserDataLoaded {
    favorite: boolean;
    alert: boolean;
    notification: boolean;
    sinalization: boolean;
}

export const initialUserState: UserState = {
    profile: null,
    notification: [],
    favorite: [],
    sinalization: [],
    notificationCounter: 0,
    alert: [],
    hideOnboarding: localStorage.getItem('emarkets-hideonboarding') === '1' || false,
    loaded: { favorite: false, alert: false, notification: false, sinalization: false }
};

export function getInitialUserState(): UserState {
    return initialUserState;
}
